import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { InputGroupAddonModule } from 'primeng/inputgroupaddon';
import { InputIconModule } from 'primeng/inputicon';
import { InputMaskModule } from 'primeng/inputmask';
import { InputNumberModule } from 'primeng/inputnumber';
import { InputTextModule } from 'primeng/inputtext';
import { ListboxModule } from 'primeng/listbox';
import { MenuModule } from 'primeng/menu';
import { BaseControlComponent } from './base-control.component';
import { HelpTextComponent } from './help-text.component';

@Component({
  selector: 'app-listbox',
  imports: [
    ReactiveFormsModule,
    CommonModule,
    InputTextModule,
    InputIconModule,
    InputNumberModule,
    InputMaskModule,
    MenuModule,
    InputGroupAddonModule,
    ButtonModule,
    ListboxModule,
    HelpTextComponent,
  ],

  template: `
    @if (showLabel) {
      <div class="tw-font-bold tw-pb-1 tw-pl-2" [id]="id + '-label'">
        {{ label }}
      </div>
    }

    <div class="tw-flex">
      <p-listbox
        autocomplete="off"
        [options]="options"
        [formControl]="control"
        [id]="id"
        [multiple]="true"
        [checkbox]="true"
        [filter]="filter"
        [optionLabel]="optionLabel"
        [optionValue]="optionValue"
        [optionDisabled]="optionDisabled"
        [showToggleAll]="false"
        [scrollHeight]="scrollHeight"
        [ariaRequired]="required"
        [attr.aria-labelledby]="ariaLabelledBy || (showLabel && label ? id + '-label' : null)"
        [attr.aria-label]="!ariaLabelledBy && !showLabel && label ? label : null"
        (onBlur)="blurred()"
        [class]="{
          'ng-invalid': touchedInvalid,
          'ng-dirty': touchedInvalid,
          'tw-grow': true,
        }"
      />
      @if (required) {
        <div aria-hidden="true" class=" tw-px-2 tw-grow-0">*</div>
      }
    </div>

    @if (showHelpText) {
      <app-help-text
        [control]="control"
        [label]="label"
        [id]="id"
        [helpText]="helpText"
      />
    }
  `,
  styles: ``,
})
export class ListboxComponent extends BaseControlComponent {
  @Input()
  options: any[];

  @Input()
  filter = false;

  @Input({ required: false })
  optionLabel: string;

  @Input({ required: false })
  optionValue: string;

  @Input({ required: false })
  optionDisabled = 'disabled';

  /**
   * Set the height of the viewport before scrolling. Default 21.5rem (shows 8 items)
   */
  @Input()
  scrollHeight = '21.5rem';

  @Input()
  showLabel = true;

  /** ID of the element that labels this listbox (WCAG: use when label is rendered outside the control). */
  @Input()
  ariaLabelledBy: string;

  blurred() {
    this.control.markAsTouched();
    // this.control.updateValueAndValidity();
  }
}
